import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DropdownSelectMixin } from '../../mixins/components/DropdownSelectMixin';
import { Combobox } from '../Combobox/Combobox';

/**
 * If you are not customizing options with `appearance`, `icons`, or `meta` from
 * ListboxOption, or using a multiselectable dropdown,
 * then it is better to use the Select component because
 * mobile browsers will optimize the user interaction.

 * @extends Combobox
 * @since 8.28.0
 */

var DropdownSelect = /*#__PURE__*/styled(Combobox).withConfig({
  displayName: "DropdownSelect",
  componentId: "c11n-8-111-1__sc-8nfqab-0"
})(["", ""], DropdownSelectMixin);
DropdownSelect.displayName = 'DropdownSelect';
DropdownSelect.propTypes = {
  /**
   * @ignore
   */
  editable: PropTypes.bool,
  /**
   * The value of the select when used as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   *
   * This should be a string, or an array of strings for a multiselectable select.
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  /**
   * The value of the select when used as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   *
   * This should be a string, or an array of strings for a multiselectable select.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  /**
   * An array of options, or an array of optgroups that will be passed to the
   * Listbox dialog. See Listbox for more information.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  options: PropTypes.array,
  /**
   * Sometimes we need to render the input's dropdown outside of the parent, if so, set to `true`
   * and the dropdown will render as a direct child of the `body` element
   *
   * @default false
   */
  isDropdownPortal: PropTypes.bool
};
DropdownSelect.defaultProps = {
  editable: false
};

/** @component */
export { DropdownSelect };